import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SearchItemComponent } from './search-item.component';
import { PipesModule } from '../pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [SearchItemComponent],
  imports: [CommonModule, TranslateModule, PipesModule],
  exports: [SearchItemComponent],
})
export class SearchItemModule {}
